import axios from 'axios'

class ProductsService {
  getProducts = (
    page,
    size,
    sortType,
    sortOrder,
    filterByCategoryId,
    filterByVisibility,
    search,
    isSubscriptionVisible = false,
    filterByProductSizes = null,
  ) => {
    const productSizesParam = Array.isArray(filterByProductSizes)
      ? filterByProductSizes.filter((v) => typeof v === 'string' && v.length > 0)
      : filterByProductSizes
        ? [filterByProductSizes]
        : []

    return axios({
      url: 'products/admin',
      method: 'GET',
      params: {
        page,
        take: size,
        asc: sortType && sortOrder === 'ascend' ? sortType : null,
        desc: sortType && sortOrder === 'descend' ? sortType : null,
        categoryId: filterByCategoryId,
        isVisible: filterByVisibility ?? undefined,
        search: search ? search : null,
        isSubscriptionVisible,
        productSizes: productSizesParam.length > 0 ? productSizesParam.join(',') : undefined,
      },
    })
  }
  getSupProducts = () =>
    axios({
      url: 'products/pull',
      method: 'GET',
    })

  getProductSizes = (categoryId = null) =>
    axios({
      url: 'products/sizes',
      method: 'GET',
      params: categoryId ? { categoryId } : undefined,
    })

  getProductById = (id) =>
    axios({
      url: `products/${id}`,
      method: 'GET',
    })

  updateProduct = (id, data) =>
    axios({
      url: `products/${id}`,
      method: 'PUT',
      data,
    })
}

export default new ProductsService()
